import { useContext } from "react";
import UserDataContext from "../contexts/UserDataContext";

const useCurrentUser = () => {
  return useContext(UserDataContext);
};

export default useCurrentUser;
